import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  TextField, 
  Box, 
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const FeedbackDialog = ({ 
  open, 
  onClose, 
  onSubmit, 
  feedback, 
  setFeedback,
  themeColors,
  negativeRatings = []
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 1,
          border: `1px solid ${themeColors.borderColor}`
        }
      }}
    >
      <DialogTitle sx={{ 
        bgcolor: themeColors.primary,
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 1.5
      }}>
        <Typography variant="h6" component="div" fontWeight={500}>
          We Value Your Feedback
        </Typography>
        <IconButton 
          size="small" 
          onClick={onClose}
          sx={{ color: 'white' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 3 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You've selected "Strongly Disagree", "Disagree", or "Neutral" for one or more ratings. 
          Please help us understand why so we can improve our services.
        </Typography>
        
        {negativeRatings.length > 0 && (
          <Box sx={{ 
            mb: 3, 
            p: 2, 
            backgroundColor: '#fff8e1',
            borderRadius: 1,
            border: '1px solid #ffe082'
          }}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1, color: '#e65100' }}>
              Your lower ratings:
            </Typography>
            <List dense disablePadding>
              {negativeRatings.map((item, index) => (
                <ListItem key={index} sx={{ py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 30 }}>
                    <SentimentVeryDissatisfiedIcon 
                      fontSize="small" 
                      color={item.rating === 'Neutral' ? 'action' : 'error'} 
                    />
                  </ListItemIcon>
                  <ListItemText 
                    primary={
                      <Typography variant="body2" fontWeight={500}>
                        {item.question.label}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="caption" color={item.rating === 'Neutral' ? 'textSecondary' : 'error'}>
                        {item.rating}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
        
        <Divider sx={{ mb: 2 }} />
        
        <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1, color: themeColors.primary }}>
          Your suggestions to help us improve:
        </Typography>
        
        <TextField
          fullWidth
          multiline
          rows={5}
          value={feedback || ''}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Please let us know why you gave these ratings and how we can improve our services..."
          variant="outlined"
          required
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: themeColors.primary,
              },
            },
          }}
        />
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 3 }}>
       
        <Button 
          onClick={onSubmit} 
          disabled={!feedback}
          variant="contained"
          sx={{
            bgcolor: feedback ? themeColors.primary : '#e0e0e0',
            color: feedback ? 'white' : '#9e9e9e',
            '&:hover': {
              bgcolor: feedback ? '#600000' : '#e0e0e0',
            }
          }}
        >
          Submit Feedback
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackDialog;